import { Controller } from "@hotwired/stimulus"

// Manages the suggested questions form on the product edit page
export default class extends Controller {
  static targets = ["item", "template"]

  add(event) {
    event.preventDefault()

    if (!this.hasTemplateTarget) {
      console.warn("[suggested-questions] No template target found")
      return
    }

    // Clone the template content
    const template = this.templateTarget
    const clone = template.content.cloneNode(true)

    // Insert before the add button
    const addButton = event.currentTarget
    addButton.parentNode.insertBefore(clone, addButton)

    // Update the question number label
    this.updateLabels()
  }

  remove(event) {
    event.preventDefault()

    // Find the parent item and remove it
    const item = event.currentTarget.closest('[data-suggested-questions-target="item"]')
    if (item) {
      item.remove()
      this.updateLabels()
    }
  }

  updateLabels() {
    // Update question number labels
    this.itemTargets.forEach((item, index) => {
      const label = item.querySelector('label')
      if (label) {
        label.textContent = `Question ${index + 1}`
      }
    })
  }
}
